import { ClaimStatus, RawClaim } from 'domains/billing';
import { isClaimFinalized, isPatientPaymentPaid } from 'domains/claims/status';

/** Returns the REAL balance of a claim, regardless of display logic */
export const getRealClaimBalance = (rootClaim: RawClaim) => {
  const claim = rootClaim.claims[0];

  const patientResponsibility = claim.service_lines[0].patient_responsibility_cents ?? 0;

  let patientPaid = 0;

  rootClaim.patient_payments.forEach(payment => {
    if (isPatientPaymentPaid(payment.status)) {
      patientPaid += payment.amount_cents ?? 0;
    }
  });

  let manualDeductions = 0;

  claim.service_lines[0].service_line_manual_adjustments.forEach(adjustment => {
    manualDeductions += adjustment.adjustment_amount_cents ?? 0;
  });

  const resultBalance = patientResponsibility - (patientPaid + manualDeductions);

  return resultBalance;
};

export const getShownClaimBalance = (realBalance: number, status: ClaimStatus) => {
  if (isClaimFinalized(status)) {
    return realBalance;
  }

  // Not finalized, truncate negative balances to 0
  if (realBalance < 0) {
    return 0;
  }

  return realBalance;
};
